require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2006-06-16-un-google.json") })
        }
      }, "path---articles-2006-06-16-un-google");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2006-06-16-un-google!./.cache/json/articles-2006-06-16-un-google.json
// module id = 469
// module chunks = 231608221292675